import React from 'react';
import HeroSection from '../components/HeroSection.js';
import ServicesSection from '../components/ServicesSection.js';
import Testimonials from '../components/Testimonials.js';
import FAQ from '../components/FAQ.js';
import Services from '../components/Services.js';
import './HomePage.css';
import PricingPackages from '../components/PricingPackages.js';
import DesignProcess from '../components/DesignProcess.js';
import useScrollToTop from '../components/useScrollToTop.js';
import WhyChooseUs from '../components/WhyChooseUs.js';
import GetQuoteForm from '../components/GetQuoteForm.js';
import ProjectGallery from '../components/ProjectGallery.js';
import kitchenimg5 from '../img/kitchen_img_5.avif';
import kitchenimg6 from '../img/kitchen_img_6.avif';
import kitchenimg8 from '../img/kitchen_img_8.avif';
import hallimg from '../img/hall_img_1.avif';
import livingroomimg1 from '../img/living_room_img_1.avif';
import livingroomimg2 from '../img/living_room_img_2.avif';
import livingroomimg3 from '../img/living_room_img_3.avif';
import bedroomimg1 from '../img/room_img_1.avif';
import bedroomimg2 from '../img/room_img_3.avif';
import bedroomimg3 from '../img/room_img_3.avif';
import AboutUs from '../components/AboutUs.js';
import homefaqData from '../components/homefaqData.js'
import HomePageLanding from '../components/HomePageLanding.js';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';


const HomePage = () => {

  useScrollToTop();
  const projectImages = [kitchenimg5,kitchenimg6,kitchenimg8,hallimg,
    livingroomimg1,livingroomimg2,livingroomimg3,bedroomimg1,bedroomimg2,bedroomimg3,

  ];
  const landingTitle = "Building Dreams, Designing Spaces - Across Bihar";
  const landingDescription = (
    <>
      Leading construction and interior design across Bihar. We build quality homes and commercial spaces,
      crafting inspiring interiors with innovation and a client-focused approach.
      From construction to bespoke design for residential, commercial, and hospitality sectors.
      Let's bring your vision to life. Contact us to start your project.
    </>
  );
  const callToAction = (
    <Link to="/projects">
      <button className="call-to-action">
        Projects <FontAwesomeIcon icon={faArrowUp} className="arrow" />
      </button>
    </Link>
  );

  
    return (
      <>
      <div>
        <HomePageLanding
        title={landingTitle}
        description={landingDescription}
      >
       {callToAction}
      </HomePageLanding>
       <div>
       <HeroSection />
        <AboutUs/>
        <ServicesSection />
        <Services />
        <WhyChooseUs/>
        
        <DesignProcess/>
        <ProjectGallery images={projectImages} />
        <PricingPackages/>
        <GetQuoteForm/>
        <Testimonials /> 
        <FAQ faqData ={homefaqData} />
      </div>
      </div>
      </>
    );
  };
  
  export default HomePage;